import { render, staticRenderFns } from "./navbarDetail.vue?vue&type=template&id=61306c01"
import script from "./navbarDetail.vue?vue&type=script&lang=js"
export * from "./navbarDetail.vue?vue&type=script&lang=js"
import style0 from "./navbarDetail.vue?vue&type=style&index=0&id=61306c01&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports